import { Grid } from "@mui/material";
import { useEffect, useState } from "react";

import BoltIcon from "@mui/icons-material/Bolt";
import BusinessIcon from "@mui/icons-material/Business";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PeopleIcon from "@mui/icons-material/People";
import SolarPowerIcon from "@mui/icons-material/SolarPower";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  Typography,
} from "@mui/material";
import DefaultApiService from "../../../../infrastructure/api/default";
import BreadcrumbsComponent from "../../../components/shared/breadcrumbs";
import BarChartCustom from "../../../components/shared/chart/BarChartCustom";

const SatbaDashboardPage = () => {
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalContractors: 0,
    totalRequests: 0,
    totalPlants: 0,
    totalCapacityKW: 0,
  });
  const [monthlyRequestsData, setMonthlyRequestsData] = useState([]);
  const [plantsByProvinceData, setPlantsByProvinceData] = useState([]);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        
        // دریافت آمار کلان از API
        const statsRes = await DefaultApiService.getApi("SLN/Satba/Satba/GetStatistics", {}, true);
        if (statsRes?.isSuccess && statsRes?.data) {
          setStats({
            totalUsers: statsRes.data.totalUsers || 0,
            totalContractors: statsRes.data.totalContractors || 0,
            totalRequests: statsRes.data.totalRequests || 0,
            totalPlants: statsRes.data.totalPlants || 0,
            totalCapacityKW: statsRes.data.totalCapacityKW || 0,
          });
        }

        // دریافت داده‌های نمودار ماهانه
        const chartRes = await DefaultApiService.getApi("SLN/Satba/Satba/GetMonthlyRequestsChart", {}, true);
        if (chartRes?.isSuccess && chartRes?.data && chartRes.data.length > 0) {
          // تبدیل داده‌ها به فرمت مورد نیاز نمودار
          const formattedData = (chartRes.data || []).map(item => ({
            MonthName: `${item.monthName} ${item.year}`,
            تعداد: item.count
          }));
          setMonthlyRequestsData(formattedData);
        } else {
          // داده‌های فیک برای نمودار ماهانه
          const fakeMonthlyData = [
            { MonthName: "فروردین 1403", تعداد: 45 },
            { MonthName: "اردیبهشت 1403", تعداد: 62 },
            { MonthName: "خرداد 1403", تعداد: 58 },
            { MonthName: "تیر 1403", تعداد: 73 },
            { MonthName: "مرداد 1403", تعداد: 81 },
            { MonthName: "شهریور 1403", تعداد: 69 },
            { MonthName: "مهر 1403", تعداد: 87 },
            { MonthName: "آبان 1403", تعداد: 94 },
            { MonthName: "آذر 1403", تعداد: 76 },
            { MonthName: "دی 1403", تعداد: 88 },
            { MonthName: "بهمن 1403", تعداد: 92 },
            { MonthName: "اسفند 1403", تعداد: 105 },
          ];
          setMonthlyRequestsData(fakeMonthlyData);
        }

        // دریافت داده‌های نمودار استان‌ها
        const provinceChartRes = await DefaultApiService.getApi("SLN/Satba/Satba/GetPlantsByProvinceChart", {}, true);
        if (provinceChartRes?.isSuccess && provinceChartRes?.data && provinceChartRes.data.length > 0) {
          // تبدیل داده‌ها به فرمت مورد نیاز نمودار
          const formattedProvinceData = (provinceChartRes.data || []).map(item => ({
            ProvinceName: item.provinceName,
            تعداد: item.count
          }));
          setPlantsByProvinceData(formattedProvinceData);
        } else {
          // داده‌های فیک برای نمودار استان‌ها
          const fakeProvinceData = [
            { ProvinceName: "تهران", تعداد: 245 },
            { ProvinceName: "اصفهان", تعداد: 189 },
            { ProvinceName: "فارس", تعداد: 167 },
            { ProvinceName: "خراسان رضوی", تعداد: 142 },
            { ProvinceName: "آذربایجان شرقی", تعداد: 128 },
            { ProvinceName: "خوزستان", تعداد: 115 },
            { ProvinceName: "مازندران", تعداد: 98 },
            { ProvinceName: "گیلان", تعداد: 87 },
            { ProvinceName: "البرز", تعداد: 76 },
            { ProvinceName: "کرمان", تعداد: 65 },
          ];
          setPlantsByProvinceData(fakeProvinceData);
        }
        
        setLoading(false);
      } catch (error) {
        console.error("خطا در دریافت داده‌های داشبورد:", error);
        // در صورت خطا، داده‌های فیک را نمایش می‌دهیم
        const fakeMonthlyData = [
          { MonthName: "فروردین 1403", تعداد: 45 },
          { MonthName: "اردیبهشت 1403", تعداد: 62 },
          { MonthName: "خرداد 1403", تعداد: 58 },
          { MonthName: "تیر 1403", تعداد: 73 },
          { MonthName: "مرداد 1403", تعداد: 81 },
          { MonthName: "شهریور 1403", تعداد: 69 },
          { MonthName: "مهر 1403", تعداد: 87 },
          { MonthName: "آبان 1403", تعداد: 94 },
          { MonthName: "آذر 1403", تعداد: 76 },
          { MonthName: "دی 1403", تعداد: 88 },
          { MonthName: "بهمن 1403", تعداد: 92 },
          { MonthName: "اسفند 1403", تعداد: 105 },
        ];
        const fakeProvinceData = [
          { ProvinceName: "تهران", تعداد: 245 },
          { ProvinceName: "اصفهان", تعداد: 189 },
          { ProvinceName: "فارس", تعداد: 167 },
          { ProvinceName: "خراسان رضوی", تعداد: 142 },
          { ProvinceName: "آذربایجان شرقی", تعداد: 128 },
          { ProvinceName: "خوزستان", تعداد: 115 },
          { ProvinceName: "مازندران", تعداد: 98 },
          { ProvinceName: "گیلان", تعداد: 87 },
          { ProvinceName: "البرز", تعداد: 76 },
          { ProvinceName: "کرمان", تعداد: 65 },
        ];
        setMonthlyRequestsData(fakeMonthlyData);
        setPlantsByProvinceData(fakeProvinceData);
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  // کارت‌های آماری اصلی
  const statCards = [
    {
      title: "تعداد کاربران",
      value: stats.totalUsers.toLocaleString("fa-IR"),
      sub: "کاربر ثبت‌نام شده",
      color: "#1976d2",
      icon: <PeopleIcon />,
    },
    {
      title: "تعداد پیمانکاران",
      value: stats.totalContractors.toLocaleString("fa-IR"),
      sub: "پیمانکار فعال",
      color: "#9c27b0",
      icon: <BusinessIcon />,
    },
    {
      title: "تعداد درخواست‌ها",
      value: stats.totalRequests.toLocaleString("fa-IR"),
      sub: "درخواست ثبت شده",
      color: "#2e7d32",
      icon: <SolarPowerIcon />,
    },
    {
      title: "نیروگاه‌های احداث شده",
      value: stats.totalPlants.toLocaleString("fa-IR"),
      sub: "نیروگاه فعال",
      color: "#ed6c02",
      icon: <CheckCircleIcon />,
    },
    {
      title: "ظرفیت کل نیروگاه‌ها",
      value: `${stats.totalCapacityKW.toLocaleString("fa-IR")} کیلووات`,
      sub: "ظرفیت کل نصب شده",
      color: "#d32f2f",
      icon: <BoltIcon />,
    },
  ];

  return (
    <Box
      sx={{
        px: { xs: 1, md: 2 },
        py: { xs: 1, md: 1.5 },
        background: "#F6F8FB",
      }}
    >
      {/* نوار بالای داشبورد */}
      <Box sx={{ mb: 1.5 }}>
        <BreadcrumbsComponent />
        <Typography variant="h5" fontWeight={700} sx={{ mt: 1 }}>
          داشبورد ساتبا (مدیران وزارت نیرو)
        </Typography>
      </Box>

      {/* کارت‌های آمار */}
      <Grid container spacing={1.5} sx={{ mb: 1.5 }}>
        {statCards.map((card, idx) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={idx >= 4 ? 6 : idx >= 3 ? 4 : 4}
            key={idx}
          >
            <Card 
              sx={{ 
                borderRadius: 3, 
                boxShadow: 1,
                transition: "all 0.3s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: 3,
                },
              }}
            >
              <CardContent sx={{ py: 1.5, px: 2, "&:last-child": { pb: 1.5 } }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
                  <Avatar
                    sx={{ bgcolor: card.color, mr: 1, width: 36, height: 36 }}
                  >
                    {card.icon}
                  </Avatar>
                  <Typography fontWeight={700} fontSize={14}>
                    {card.title}
                  </Typography>
                </Box>
                <Typography fontWeight={700} fontSize={20} color={card.color}>
                  {card.value}
                </Typography>
                <Typography fontSize={13} color="text.secondary">
                  {card.sub}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* نمودارها */}
      <Grid container spacing={1.5}>
        {/* نمودار میله‌ای ماهانه */}
        <Grid item xs={12} md={6}>
          <Card sx={{ borderRadius: 3, boxShadow: 1 }}>
            <CardHeader
              title="نمودار ماهانه درخواست‌های ثبت شده"
              sx={{ pb: 0, pt: 1.5, px: 2 }}
              titleTypographyProps={{ fontSize: 15, fontWeight: 600 }}
            />
            <CardContent sx={{ py: 1, px: 2 }}>
              <Box sx={{ height: 400 }}>
                {loading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Typography>در حال بارگذاری...</Typography>
                  </Box>
                ) : monthlyRequestsData.length > 0 ? (
                  <BarChartCustom
                    title="تعداد درخواست‌های ثبت شده به تفکیک ماه"
                    xAxis="MonthName"
                    xAxisTitle="ماه"
                    yAxisTitle="تعداد درخواست"
                    data={monthlyRequestsData}
                    series={["تعداد"]}
                    colors={["#1976d2"]}
                  />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Typography color="text.secondary">
                      داده‌ای برای نمایش وجود ندارد
                    </Typography>
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* نمودار میله‌ای تعداد نیروگاه‌ها به تفکیک استان */}
        <Grid item xs={12} md={6}>
          <Card sx={{ borderRadius: 3, boxShadow: 1 }}>
            <CardHeader
              title="نمودار تعداد نیروگاه‌ها به تفکیک استان"
              sx={{ pb: 0, pt: 1.5, px: 2 }}
              titleTypographyProps={{ fontSize: 15, fontWeight: 600 }}
            />
            <CardContent sx={{ py: 1, px: 2 }}>
              <Box sx={{ height: 400 }}>
                {loading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Typography>در حال بارگذاری...</Typography>
                  </Box>
                ) : plantsByProvinceData.length > 0 ? (
                  <BarChartCustom
                    title="تعداد نیروگاه‌های احداث شده به تفکیک استان"
                    xAxis="ProvinceName"
                    xAxisTitle="استان"
                    yAxisTitle="تعداد نیروگاه"
                    data={plantsByProvinceData}
                    series={["تعداد"]}
                    colors={["#2e7d32"]}
                  />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Typography color="text.secondary">
                      داده‌ای برای نمایش وجود ندارد
                    </Typography>
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SatbaDashboardPage;
